/**
 * Exception for all exceptions thrown by an Implementing Library
 */
export class CacheException extends Error {
    // no content
}
